import { createFeatureSelector, createSelector } from '@ngrx/store';

import { UserState } from './init-user.reducer';

export const getUserState = createFeatureSelector<UserState>('user');

export const getUser = createSelector(getUserState, (state) => state.entity);

/*export const getLoading = createSelector(
  getUserState,
  (state) => state.loading
);*/

/*export const isAuthorized = createSelector(
  getUserState,
  (state) => !!state._id
);*/

export const getClientData = createSelector(
  getUserState,
  (state) => state.clientData
);
